import {
  ClearRounded,
  EditRounded,
} from "@mui/icons-material";
import {
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";

import { Alert, Table } from "../../layout";
import * as actions from "../../api/actions/pos";
import {
  controller,
  endpoints,
} from "../../api/actions/api";
import AddEditStorePrinter from "./AddEditStorePrinter";

const StorePrinters = (props) => {
  const { t } = useTranslation();
  const { _getById, _delete } = props;

  const { storeId } = useParams();
  //const navigate = useNavigate();

  const [printers, setPrinters] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [updData, setUpdData] = useState(undefined);
  const [refresh, setRefresh] = useState(0);

  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    if (!storeId) return;

    const onComplete = (res, err) => {
      if (err) {
        console.error("Store printers:", err);
        setPrinters([]);
        return;
      }

      if (res?.status === 200) {
        setPrinters(res.result || []);
      } else {
        setPrinters([]);
      }
    };

    _getById(
      endpoints.StorePrinter + controller.GetByStore,
      storeId,
      null,
      onComplete
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeId, refresh]);

  const handleAdd = () => {
    console.log("Add Printer - Store:", storeId);
    setUpdData(undefined);
    setShowForm(true);
  };

  const handleEdit = (printer) => {
    console.log("Edit Printer:", printer);
    setUpdData(printer);
    setShowForm(true);
  };

  const handleDelete = (id) => {
  setAlert({
    isOpen: true,
    type: "confirmation",
    title: t("deletePrinter"),
    subTitle: t("deletePrinterConfirmation"),
    onConfirm: () => {
      const onComplete = (res, err) => {
        if (err) {
          setAlert({
            isOpen: true,
            type: "error",
            title: t("error"),
            subTitle:
              err?.msg ||
              err?.message ||
              t("unableToDeletePrinter"),
          });
          return;
        }

        if (res?.status === 200) {
          setAlert({
            isOpen: true,
            type: "success",
            title: t("deletedSuccessfully"),
            subTitle:
              res?.msg ||
              t("printerDeletedSuccessfully"),
          });

          setRefresh((prev) => prev + 1);
        }
      };

      _delete(
        endpoints.StorePrinter,
        id,
        null,
        onComplete
      );
    },
  });
};

  const ActionComp = (printer) => (
    <Box>
      <Tooltip arrow title={t("edit")}>
        <IconButton
          onClick={() => handleEdit(printer)}
          size="small"
          className="btn-primary mr-5"
        >
          <EditRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>

      <Tooltip arrow title={t("delete")}>
        <IconButton
          onClick={() => handleDelete(printer.id)}
          size="small"
          className="btn-error"
        >
          <ClearRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
    </Box>
  );

  const HeaderComp = () => (
    <Button
      onClick={handleAdd}
      className="btn-secondary"
      sx={{
        width: { md: "180px", xs: "100%" },
        mb: { xs: "10px", md: "0px" },
        fontSize: "17px",
        padding: "8px",
      }}
    >
      {t("addPrinter")}
    </Button>
  );

  const tableData = printers.map((printer) => ({
    ...printer,

    printerTypeName:
      printer.printerType === 1
        ? t("posReceipt")
        : printer.printerType === 2
        ? t("reports")
        : printer.printerType === 3
        ? t("barcodeLabel")
        : t("other"),

    connectionTypeName:
      printer.connectionType === 1
        ? t("windowsUsb")
        : printer.connectionType === 2
        ? t("network")
        : t("other"),

    paperWidthName: `${printer.paperWidth} mm`,

    ipAddressName: printer.ipAddress || "-",
    portName: printer.port || "-",

    defaultName: printer.isDefault ? t("yes") : t("no"),
    activeName: printer.isActive ? t("yes") : t("no"),
    autoPrintName: printer.autoPrint ? t("yes") : t("no"),
  }));
  return (
    <>
    {!showForm ? (
    <Table
      ActionComp={ActionComp}
      HeaderComp={HeaderComp}
      tblHead={[
        { id: "actions", label: t("actions") },
        { id: "printerName", label: t("printerName") },
        { id: "printerTypeName", label: t("printerType") },
        { id: "driverName", label: t("driver") },
        { id: "paperWidthName", label: t("paperWidth") },
        { id: "connectionTypeName", label: t("connection") },
        { id: "ipAddressName", label: t("ipAddress") },
        { id: "portName", label: t("port") },
        { id: "defaultName", label: t("default") },
        { id: "activeName", label: t("active") },
        { id: "autoPrintName", label: t("autoPrint") },
      ]}

      tblData={tableData}
     />
    ) : (
      <AddEditStorePrinter
        updData={updData}
        setShowForm={setShowForm}
        storeId={storeId}
        refreshPrinters={() => setRefresh((prev) => prev + 1)}
      />
    )}

    <Alert
      alert={alert}
      setAlert={setAlert}
    />

  </>
  );
};

const mapActionToProps = {
  _getById: actions.getById,
  _delete: actions.Delete,
};

export default connect(
  null,
  mapActionToProps
)(StorePrinters);